import React, { Component } from 'react';

import {
    Container,
    Loading,
    Button,
    DeleteButton,
    ArchiveButton,
    Dropdown,
    SortableList,
    Form,
    FileInput,
    TextInput,
} from 'library';
import {
    ajax_wrapper,
    get_global_state,
    sort_objects,
    toast_handler,
    export_project,
} from 'functions';
import { SongCard, DynamicSearch, TagDisplay } from 'components';
import $, { param } from 'jquery';

function focus_on_page() {
    setTimeout(function () {
        var x = window.scrollX,
            y = window.scrollY;
        $('.project-page-container').focus();
        window.scrollTo(x, y);
    }, 100);
}

class ProjectTitle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editor_mode: false,
            save_button_text: 'Save',
            name: this.props.name,
        };
    }

    update_name_state = (e) => {
        this.setState({ name: e.target.value });
    };

    submit_name_change = () => {
        this.setState({ save_button_text: 'Saving...' });
        ajax_wrapper(
            'POST',
            `/api/update_project_name/${this.props.project_id}/`,
            { name: this.state.name },
            () =>
                this.setState({ editor_mode: false, save_button_text: 'Save' }),
        );
    };

    cancel_name_change = () => {
        this.setState({ editor_mode: false });
    };

    render() {
        let jsx = [];

        if (this.state.editor_mode) {
            jsx.push(
                <div>
                    <input
                        className="edit-text-inplace-input"
                        onChange={this.update_name_state}
                        value={this.state.name}
                    />
                    <Button
                        onClick={this.submit_name_change}
                        style={{ padding: '5px', marginLeft: '10px' }}
                    >
                        {this.state.save_button_text}
                    </Button>
                    <Button
                        onClick={this.cancel_name_change}
                        style={{ padding: '5px' }}
                    >
                        Cancel
                    </Button>
                </div>,
            );
        } else {
            jsx.push(
                <div>
                    <a
                        className="proj-title-header"
                        onClick={() => this.setState({ editor_mode: true })}
                    >
                        {this.state.name}
                    </a>
                </div>,
            );
        }

        return jsx;
    }
}

export default class Project extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            data: {},
            songs_lookup: {},
            song_status_lookup: {},
            song_tags: {},
            editing_track_id: '',
            sync_status: 'Getting Sync Status...',
            show_search: false,
            search_type: '',
            search_type_id: '',
            tag_types: [],
            tag_lookup: {},
            recent_songs: [],
            filter_threshold: 100,
            filter_active: true,
            include_empty: true,
            show_all: true,
            album_description: '',
            album_tags: [],
            audio_playing: '',
            track_filter: 'Not Started',
        };
    }

    componentDidMount() {
        let params = get_global_state()['params'];
        if (!('split' in params)) {
            params['split'] = 0;
        }

        this.intervalId = setInterval(() => {
            if (
                this.state.sync_status !== 'Synced' &&
                this.state.sync_status !== ''
            ) {
                this.updateSyncStatus();
            }
        }, 2000);

        ajax_wrapper(
            'GET',
            `/api/project_details/${params['id']}/${params['split']}/`,
            {},
            this.load_project_details,
        );
    }

    load_project_details = (value) => {
        let params = get_global_state()['params'];

        let tag_lookup = {};
        let tag_types = [];

        let tag_type_ids = [];
        for (let tagtype of value['tag_types']) {
            tag_type_ids.push(tagtype.id);
        }

        for (let tagtype of value['taxonomy_tags'].sort(
            (a, b) => a.order - b.order,
        )) {
            if (tag_type_ids.includes(tagtype.id)) {
                tag_types.push(tagtype);

                for (let item of tagtype['tags']) {
                    tag_lookup[item['id']] = item;
                    for (let child of item['children']) {
                        tag_lookup[child['id']] = child;
                    }
                }
            }
        }

        this.setState({
            data: value,
            split_number: params['split'],
            album_tags: value.album_tags,
            tag_types: tag_types,
            tag_lookup: tag_lookup,
        });

        ajax_wrapper(
            'GET',
            `/api/project_songs_details/${params['id']}/`,
            {},
            this.load_song_details,
        );
    };

    load_song_details = (value) => {
        let songs_lookup = {};
        let song_status_lookup = {};

        for (let song of value) {
            let song_status = song.status_by_split[this.state.split_number]
                ? song.status_by_split[this.state.split_number]['status']
                : 'Not Started';
            songs_lookup[song.id] = song;
            song_status_lookup[song.id] = song_status;
        }

        this.setState(
            {
                loaded: true,
                songs_lookup: songs_lookup,
                song_status_lookup: song_status_lookup,
            },
            this.load_recent_songs,
        );
    };

    show_hide_all = () => {
        this.setState({ show_all: this.state.show_all ? false : true });
    };

    updateSyncStatus = () => {
        let params = get_global_state()['params'];
        ajax_wrapper(
            'GET',
            `/api/get_sync_status/${params['id']}/`,
            {},
            (response) => {
                let sync_status = '';

                if (response.status === 'No Running Syncs') {
                    // Tracks already synced don't need indicator
                    // Tracks left on the syncing page will display
                    // 'Synced' when finished
                    if (this.state.sync_status === 'Getting Sync Status...') {
                        sync_status = '';
                    } else {
                        sync_status = 'Synced';
                    }
                } else {
                    sync_status = response.status;
                }

                this.setState({ sync_status: sync_status });
            },
        );
    };

    delete_project = () => {
        ajax_wrapper(
            'POST',
            `/api/delete_project/${this.state.data.id}/`,
            {},
            (value) => (window.location = `/`),
        );
    };

    mark_project_complete = () => {
        ajax_wrapper(
            'POST',
            `/api/mark_project_complete/${this.state.data.id}/`,
            {},
            (value) => (window.location = `/?client=${this.state.data.client}`),
        );
    };

    load_recent_songs() {
        let params = get_global_state()['params'];
        if (!('split' in params)) {
            params['split'] = 0;
        }

        let sorted_songs = Object.keys(this.state.songs_lookup).map((key) => {
            return this.state.songs_lookup[key];
        });

        sort_objects(sorted_songs, ['updated_at']);
        sorted_songs.reverse();

        let recent_songs = [];

        for (let item of sorted_songs) {
            if (
                item['status_by_split'][params['split']] &&
                item['status_by_split'][params['split']]['status'] == 'Complete'
            ) {
                recent_songs.push(item);
            }
        }

        console.log('loaded recent songs');
        this.setState({
            recent_songs: recent_songs,
        });
    }

    copy_tags = (song_id, copy_id) => {
        let params = get_global_state()['params'];
        this.setState(
            ajax_wrapper(
                'POST',
                `/api/copy_tags/${song_id}/${copy_id}/${params['split']}/`,
                {},
                (value) => {
                    let new_songs_lookup = { ...this.state.songs_lookup };
                    new_songs_lookup[value.id].tags = value.tags;

                    this.setState(
                        { songs_lookup: new_songs_lookup },
                        this.load_recent_songs,
                    );
                },
            ),
        );
    };

    submit_album_meta = (state) => {
        this.setState({ album_data_saving: true });
        let params = get_global_state()['params'];

        let album_tag_ids = this.state.album_tags.map((tag) => tag.id);

        let data = {
            album_description: state.album_description,
            album_tags: album_tag_ids,
        };

        ajax_wrapper(
            'POST',
            `/api/update_album_meta/${params['id']}/`,
            data,
            (value) => {
                this.setState({ album_data_saving: false });
            },
        );
    };

    toggle_album_tag = (id) => {
        let tag = this.state.tag_lookup[id];
        let tags = [...this.state.album_tags];

        let found_tag = null;
        for (let item of tags) {
            if (item['id'] == id) {
                found_tag = tags.indexOf(item);
            }
        }

        if (found_tag == null) {
            tags.push(this.state.tag_lookup[id]);
        } else {
            tags.splice(found_tag, 1);
        }

        this.setState({
            album_tags: tags,
        });
    };

    toggle_song_tag = (id, song_id) => {
        let params = get_global_state()['params'];
        let data = {
            split_number: this.state.split_number,
            add: [],
            remove: [],
        };
        let tag = this.state.tag_lookup[id];
        let tag_type = null;

        for (let type of this.state.tag_types) {
            if (type.id === tag['tag_type']) {
                tag_type = type;
                break;
            }
        }

        let tags = [...this.state.songs_lookup[song_id].tags];
        let found_tag = null;
        let current_tags_of_type = [];

        for (let item of tags) {
            if (item['id'] == id) {
                found_tag = tags.indexOf(item);
            }
            if (item['tag_type'] === tag_type.id) {
                current_tags_of_type.push(item);
            }
        }

        if (found_tag == null) {
            if (current_tags_of_type.length < tag_type['max']) {
                data['add'].push(id);
                tags.push(this.state.tag_lookup[id]);
            }
        } else {
            data['remove'].push(id);
            tags.splice(found_tag, 1);
        }

        tags = sort_objects(tags, ['name']);

        let new_songs_lookup = { ...this.state.songs_lookup };

        // setting in both places in case songs_lookup tags get reused somewhere
        new_songs_lookup[song_id].tags = tags;

        this.setState(
            {
                songs_lookup: new_songs_lookup,
            },
            () =>
                ajax_wrapper(
                    'POST',
                    `/api/toggle_song_tags/${song_id}/${params['split']}/`,
                    data,
                    (value) => {
                        new_songs_lookup = { ...this.state.songs_lookup };

                        for (let tag_id of value['triggered_tags']) {
                            new_songs_lookup[song_id].tags.push(
                                this.state.tag_lookup[tag_id],
                            );
                        }

                        new_songs_lookup[song_id].status_by_split =
                            value.status_by_split;
                        new_songs_lookup[song_id].updated_at = value.updated_at;
                        this.setState(
                            { songs_lookup: new_songs_lookup },
                            this.load_recent_songs,
                        );
                    },
                ),
        );
    };

    update_presets = (song_id) => {
        let params = get_global_state()['params'];
        let split_num = params['split'];
        this.setState(
            { tags_loaded: false },
            ajax_wrapper(
                'POST',
                `/api/update_presets/${song_id}/${split_num}/`,
                {},
                (value) => {
                    let new_songs_lookup = { ...this.state.songs_lookup };

                    new_songs_lookup[song_id] = {
                        ...new_songs_lookup[song_id],
                        tags: value['tags'],
                        status_by_split: value['status_by_split'],
                    };
                    this.setState({ songs_lookup: new_songs_lookup });
                },
            ),
        );
    };

    show_search = (type_id, search_type, track_id, track_tags) => {
        this.setState({
            search_type: search_type,
            search_type_id: type_id,
            editing_track_id: track_id,
            show_search: true,
        });
    };

    onDragEnd = (result, reordered_items, callback) => {
        console.log(
            `${reordered_items[result.source.index].id} moved to ${
                result.source.index
            } :: ${reordered_items[result.destination.index].id} moved to ${
                result.destination.index
            }`,
        );

        let songs_lookup = Object.assign({}, this.state.songs_lookup);

        songs_lookup[reordered_items[result.source.index].id].order =
            result.source.index;
        songs_lookup[reordered_items[result.destination.index].id].order =
            result.destination.index;

        this.setState({ songs_lookup: songs_lookup }, callback);

        let data = {};
        data[reordered_items[result.source.index].id] = result.source.index;
        data[reordered_items[result.destination.index].id] =
            result.destination.index;

        ajax_wrapper('POST', '/api/update_songs_order/', data, function () {});
    };

    render() {
        let params = get_global_state()['params'];
        let user = get_global_state()['user'];

        let sync_status = '';
        if (this.state.sync_status !== '') {
            sync_status = (
                <div>
                    <h5
                        style={{
                            display: 'inline-block',
                            fontStyle: 'italic',
                            fontWeight: 'lighter',
                        }}
                    >
                        Sync Status:
                    </h5>
                    <p
                        style={{
                            display: 'inline-block',
                            fontWeight: 'light',
                            marginLeft: '10px',
                        }}
                    >
                        {this.state.sync_status}
                    </p>
                </div>
            );
        }

        let filtered_songs = [];
        let to_be_tagged = 0;
        let in_progress = 0;
        let complete = 0;

        let index = 0;

        let song_list = [];
        for (let key in this.state.songs_lookup) {
            song_list.push(this.state.songs_lookup[key]);
        }
        song_list = sort_objects(song_list, ['order']);

        let recent_songs_options = this.state.recent_songs.map((song) => {
            return { text: song.name, value: song.id };
        });

        for (let song of song_list) {
            let song_status = song.status_by_split[this.state.split_number]
                ? song.status_by_split[this.state.split_number]['status']
                : 'Not Started';
            if (song_status === 'Complete') {
                complete++;
            } else if (song_status === 'In Progress') {
                in_progress++;
            } else {
                to_be_tagged++;
            }

            // calculate minimum tag confidence of ML tags
            let ml_confidence_ratings = [];
            for (let tag of this.state.songs_lookup[song.id].tags) {
                if (tag.ml_generated) {
                    ml_confidence_ratings.push(tag.ml_confidence);
                } else {
                    ml_confidence_ratings.push(1);
                }
            }
            let song_ml_confidence = Math.min(...ml_confidence_ratings);
            if (
                (ml_confidence_ratings.length === 0 &&
                    this.state.include_empty) |
                (song_ml_confidence <= this.state.filter_threshold / 100)
            ) {
                let song_card = (
                    <SongCard
                        id={song.id}
                        data={song}
                        split_number={this.state.split_number}
                        song_url={song['dropbox_url']}
                        editable={true}
                        playing={this.state.audio_playing === song.id}
                        onPlayStateChange={() =>
                            this.setState({ audio_playing: song.id })
                        }
                        show={this.state.show_all}
                        tag_types={this.state.tag_types}
                        tag_lookup={this.state.tag_lookup}
                        tags={this.state.songs_lookup[song.id].tags}
                        recent_songs_options={recent_songs_options}
                        show_search={this.show_search}
                        toggle_tag={(id) => this.toggle_song_tag(id, song.id)}
                        style={{ margin: '0px' }}
                        copy_tags={this.copy_tags}
                        update_presets={this.update_presets}
                    />
                );

                // Uses song_status_lookup to filter, which is updated once on page load
                // (to keep songs from jumping into other filters while being tagged)
                if (
                    this.state.song_status_lookup[song.id] ===
                    this.state.track_filter
                ) {
                    filtered_songs.push({
                        id: song.id,
                        content: song_card,
                    });
                }
            }

            index += 1;
        }

        let export_options = [];
        if (this.state.data['export_formats']) {
            for (let format of this.state.data['export_formats']) {
                export_options.push(
                    <Button
                        type="outline-primary"
                        onClick={() => {
                            export_project(params['id'], format['id']);
                        }}
                        style={{ width: '100%' }}
                    >
                        {format['name']}
                    </Button>,
                );
            }
        }

        let album_metadata = [];

        if (
            this.state.loaded &&
            this.state.data.special_fields.includes('album_description') |
                this.state.data.special_fields.includes('album_tags')
        ) {
            let album_tags_jsx = [];
            for (let tag of this.state.album_tags) {
                album_tags_jsx.push(
                    <Button
                        className="taxonomy-pool-tag"
                        onClick={() => this.toggle_album_tag(tag.id)}
                    >
                        {tag.name}
                    </Button>,
                );
            }
            album_tags_jsx.push(
                <Button
                    className="taxonomy-pool-tag"
                    onClick={() =>
                        this.show_search('', '', '', this.state.album_tags)
                    }
                >
                    +
                </Button>,
            );
            album_metadata.push(
                <div className="simple-card">
                    <h3>Album Metadata:</h3>
                    <Form
                        defaults={{
                            album_description:
                                this.state.data.album_description,
                        }}
                        submit_text={
                            this.state.album_data_saving
                                ? 'Saving...'
                                : 'Save Changes'
                        }
                        submit={this.submit_album_meta}
                        redirect={console.log('Saved Album Meta')}
                    >
                        <TextInput
                            label="Album Description:"
                            name="album_description"
                        />
                        {album_tags_jsx}
                    </Form>
                </div>,
            );
        }

        let splits_display = [];

        return (
            <div className="project-page-container">
                <Container>
                    <Loading loaded={this.state.loaded}>
                        <DynamicSearch
                            show={this.state.show_search}
                            tag_type_name={this.state.search_type}
                            tag_type={this.state.search_type_id}
                            data={this.state.data}
                            project_view={true}
                            existing_tags={
                                this.state.editing_track_id
                                    ? this.state.songs_lookup[
                                          this.state.editing_track_id
                                      ].tags
                                    : this.state.album_tags
                            }
                            tag_types={this.state.tag_types}
                            tag_lookup={this.state.tag_lookup}
                            dropdown_categories={
                                this.state.data['dropdown_categories']
                            }
                            toggle_tag={
                                this.state.editing_track_id
                                    ? (id) =>
                                          this.toggle_song_tag(
                                              id,
                                              this.state.editing_track_id,
                                          )
                                    : (id) => this.toggle_album_tag(id)
                            }
                            on_hide={() =>
                                this.setState(
                                    {
                                        show_search: false,
                                        search_type: '',
                                        search_type_id: '',
                                    },
                                    focus_on_page,
                                )
                            }
                        />

                        {/*<div className="simple-card-container">*/}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '1rem',
                            }}
                        >
                            <h1
                                style={{
                                    margin: 0,
                                }}
                            >
                                PROJECT
                            </h1>
                            <Button
                                href={`/?client=${this.state.data.client}`}
                                style={{
                                    backgroundColor: 'rgba(0,0,0,0.1)',
                                }}
                                type="primary"
                            >
                                Back to Client: {this.state.data.client_name}
                            </Button>
                        </div>
                        <div
                            className="simple-card"
                            style={{ position: 'relative' }}
                        >
                            {['owner', 'admin'].includes(user['role']) ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '7px',
                                        float: 'right',
                                    }}
                                >
                                    <div
                                        className="project-button"
                                        style={{ marginRight: '10px' }}
                                    >
                                        <Dropdown
                                            style={{ textAlign: 'center' }}
                                        >
                                            {export_options}
                                        </Dropdown>
                                    </div>
                                    <div
                                        className="tooltip-wrapper"
                                        data-tooltip="Mark Project Complete"
                                    >
                                        <ArchiveButton
                                            src="/static/icons/project/check-fat-light.png"
                                            className="project-phosphor-button"
                                            url="/api/mark_project_complete/"
                                            callback={() =>
                                                (window.location = `/?client=${this.state.data.client}`)
                                            }
                                            value={this.state.data.id}
                                            text={'Mark Project Complete'}
                                        />
                                    </div>
                                    <div
                                        className="tooltip-wrapper"
                                        data-tooltip="Add Songs"
                                    >
                                        <a
                                            href={`/project/${params['id']}/add_songs/`}
                                        >
                                            <img
                                                className="project-phosphor-button"
                                                src="/static/icons/project/plus-circle-light.png"
                                            />
                                        </a>
                                    </div>
                                    {['owner', 'admin'].includes(
                                        user['role'],
                                    ) ? (
                                        <div
                                            className="tooltip-wrapper"
                                            data-tooltip="Delete Project"
                                        >
                                            <DeleteButton
                                                src="/static/icons/project/trash-light.png"
                                                className="project-phosphor-button"
                                                url="/api/delete_project/"
                                                callback={() =>
                                                    (window.location = `/?client=${this.state.data.client}`)
                                                }
                                                value={this.state.data.id}
                                                text={'Delete Project'}
                                            />
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}

                            <div>
                                <ProjectTitle
                                    name={this.state.data.name}
                                    project_id={this.state.data.id}
                                />
                                {/*                                <h3 style={{ display: 'inline-block' }}>
                                    {Object.keys(this.state.song_list).length}{' '}
                                    total tracks
                                </h3>*/}
                                <div
                                    className="split-display-flag"
                                    style={{
                                        display: 'inline-block',
                                        marginLeft: '10px',
                                    }}
                                >
                                    {this.state.data['split_view'] == 'Main'
                                        ? ''
                                        : this.state.data['split_view']}
                                </div>
                            </div>

                            <div>{sync_status}</div>
                            <table
                                style={{
                                    width: '20%',
                                    display: 'inline-block',
                                    borderSpacing: '15px 2px',
                                    borderCollapse: 'separate',
                                }}
                            >
                                <tr>
                                    <td>
                                        <h5>To Be Tagged:</h5>
                                    </td>
                                    <td>{to_be_tagged} tracks</td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>In Progress:</h5>
                                    </td>
                                    <td>{in_progress} tracks</td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>Complete:</h5>
                                    </td>
                                    <td>{complete} tracks</td>
                                </tr>
                            </table>
                        </div>
                        <div className="simple-card">
                            {['owner', 'admin'].includes(user['role']) ? (
                                <div
                                    style={{
                                        float: 'right',
                                        marginRight: '0px',
                                    }}
                                >
                                    <Form
                                        submit_text="Upload track notes CSV"
                                        submit_url={`/api/upload_track_notes/${this.state.data.id}/`}
                                        redirect={this.upload_track_notes}
                                    >
                                        <FileInput
                                            name="file"
                                            style={{
                                                fontSize: '12px',
                                            }}
                                        />
                                    </Form>
                                </div>
                            ) : null}
                            <h3>Project Notes:</h3>
                            <p>{this.state.data.project_notes}</p>
                        </div>
                        {album_metadata}
                        {/*<div className="simple-card">
                            
                            <table
                                style={{
                                    borderSpacing: '12px',
                                    borderCollapse: 'separate',
                                }}
                            >
                                <tr>
                                    <td
                                        style={{
                                            verticalAlign: 'middle',
                                        }}
                                    >
                                        ML Confidence:
                                    </td>
                                    <td
                                        style={{
                                            verticalAlign: 'middle',
                                            paddingTop: '8px',
                                        }}
                                    >
                                        <input
                                            type="range"
                                            min="0"
                                            max="100"
                                            value={this.state.filter_threshold}
                                            style={{}}
                                            class="slider"
                                            id="myRange"
                                            onInput={(e) =>
                                                this.setState({
                                                    filter_threshold:
                                                        e.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                    <td
                                        style={{
                                            verticalAlign: 'middle',
                                        }}
                                    >
                                        Tags less than{' '}
                                        {this.state.filter_threshold}%
                                    </td>
                                </tr>
                                <tr>
                                    <td>Include Empty:</td>

                                    <td>
                                        <input
                                            type="checkbox"
                                            style={{
                                                verticalAlign: 'middle',
                                                paddingTop: '8px',
                                            }}
                                            checked={
                                                this.state.include_empty
                                                    ? 'checked'
                                                    : null
                                            }
                                            onClick={() =>
                                                this.setState({
                                                    include_empty:
                                                        !this.state
                                                            .include_empty,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                            </table>
                        </div>*/}
                        {/*</div>*/}

                        {/*<div className="simple-card-container">*/}
                        <hr
                            id="songs_list"
                            style={{ color: 'rgba(0,0,0,0)' }}
                        />

                        <a onClick={this.show_hide_all}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <h2
                                                style={{
                                                    verticalAlign: 'center',
                                                }}
                                            >
                                                TRACKS
                                            </h2>
                                        </td>
                                        <td
                                            style={{
                                                verticalAlign: 'center',
                                                paddingBottom: '7px',
                                            }}
                                        >
                                            <img
                                                src="/static/icons/project/arrows-vertical-light.png"
                                                style={{ height: '30px' }}
                                            />
                                        </td>
                                        <td style={{ verticalAlign: 'center' }}>
                                            <h4>
                                                {this.state.show_all
                                                    ? 'Collapse '
                                                    : 'Expand '}{' '}
                                                All
                                            </h4>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </a>
                        <div
                            className="simple-card-container"
                            style={{
                                position: 'relative',
                                borderRadius: '15px 0px 15px 15px',
                            }}
                        >
                            <div
                                // className="song-filter-tabs-container"
                                style={{
                                    position: 'absolute',
                                    top: -34,
                                    right: 10,
                                    display: 'flex',
                                    gap: '10px',
                                }}
                            >
                                <a
                                    className={`song-filter-tab ${this.state.track_filter === 'Not Started' ? 'selected' : ''}`}
                                    style={{
                                        color: 'rgba(57, 126, 173)',
                                    }}
                                    onClick={() =>
                                        this.setState({
                                            track_filter: 'Not Started',
                                        })
                                    }
                                >
                                    To Be Tagged
                                </a>

                                <a
                                    className={`song-filter-tab ${this.state.track_filter === 'In Progress' ? 'selected' : ''}`}
                                    style={{
                                        color: 'rgba(34, 159, 149)',
                                    }}
                                    onClick={() =>
                                        this.setState({
                                            track_filter: 'In Progress',
                                        })
                                    }
                                >
                                    In Progress
                                </a>

                                <a
                                    className={`song-filter-tab ${this.state.track_filter === 'Complete' ? 'selected' : ''}`}
                                    style={{
                                        color: 'rgba(236, 56, 104)',
                                    }}
                                    onClick={() =>
                                        this.setState({
                                            track_filter: 'Complete',
                                        })
                                    }
                                >
                                    Completed
                                </a>
                            </div>
                            <SortableList
                                loaded={this.state.loaded}
                                drag_class="simple-card"
                                style={{ backgroundColor: 'rgba(0,0,0,0)' }}
                                items={filtered_songs}
                                onDragEnd={this.onDragEnd}
                            />
                        </div>
                        <hr />
                        <a href="#songs_list" className="floating-top-button">
                            Return to Top
                        </a>
                        {/*</div>*/}
                    </Loading>
                </Container>
            </div>
        );
    }
}
